import { showToastMessage } from "./app-utils";
import { AppRouters } from "./app-router";

/** Edit/clone load and save when GET workflow returns not found (not Reporting trace copy). */
export const WORKFLOW_NOT_FOUND_MESSAGE = "Workflow not found.";

export const WORKFLOW_VIEW_FORBIDDEN_MESSAGE =
  "You do not have permission to view this workflow.";

/** Toast (if applicable) and redirect when workflow GET fails. Skips toast when undefined — jha-fetch already toasted. */
export function abortWorkflowLoad(workData: unknown): void {
  if (workData instanceof Response && workData.status === 401) {
    showToastMessage(WORKFLOW_VIEW_FORBIDDEN_MESSAGE, "danger");
  } else if (workData !== undefined) {
    showToastMessage(WORKFLOW_NOT_FOUND_MESSAGE, "danger");
  }
  AppRouters.go("/workflows");
}
